import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const Wrapper = styled.div`
  display: flex;
  width: 375px;
  padding: 32px 24px 64px;
  flex-direction: column;
  justify-content: center;
  align-self: stretch;
  margin: 0 auto;
  gap: 64px;

  @media (min-width: ${breakpoints.tablet}) {
    width: 744px;
    padding: 48px 32px 80px;
    gap: 32px;
    max-height: inherit;
    margin: 0 auto;
    overflow-y: auto;
    overflow-x: hidden;
    -ms-overflow-style: none;
    scrollbar-width: 0;
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    width: 1440px;
    padding: 80px 80px 120px;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  align-self: stretch;

  @media (min-width: ${breakpoints.tablet}) {
    justify-content: center;
    gap: 80px;
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 48px;
    align-self: stretch;
  }
`;

export const Container = styled.div`
  display: flex;
  padding: 32px 24px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  border: 1px solid var(--new-palette-default-monochrome-monochrome3, #bebebe);
  background: var(--new-palette-default-primary-primary2, #fff);

  @media (min-width: ${breakpoints.tablet}) {
    padding: 32px 47px;
    align-self: center;
    width: 680px;
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    width: 1062px;
    padding: 32px 47px;
  }
`;
export const Disclamer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;

  @media (min-width: ${breakpoints.tablet}) {
    align-self: stretch;
  }
`;

export const Title = styled.div`
  font-family: ${fonts.exbold};
  font-weight: 400;
  ${pxToCssFont(28, 36)}
  color: ${colors.$262626};
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  text-align: center;
  display: flex;
  padding-bottom: 8px;

  @media (min-width: ${breakpoints.desktop}) {
    display: flex;
    ${pxToCssFont(36, 48)}
  }
`;

export const Text = styled.div`
  font-family: ${fonts.regular};
  font-style: normal;
  font-weight: 400;
  color: ${colors.$262626};
  ${pxToCssFont(16, 22)}

  @media (min-width: ${breakpoints.tablet}) {
    ${pxToCssFont(18, 24)}
  }
`;

export const Description = styled.div`
  align-self: stretch;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;

  @media (min-width: ${breakpoints.bigDesktop}) {
    column-gap: 32px;
  }
`;
export const InputRow = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px;
  align-self: stretch;
  flex-wrap: wrap;

  .textInput {
    flex: 1 1 100%;
    width: 100%;
    box-sizing: border-box;
  }

  @media (min-width: ${breakpoints.tablet}) {
    gap: 24px;

    .textInput {
      flex: 1 1 calc(50% - 12px);
    }
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    .textInput {
      flex: 1 0 0;
      width: 100%;
    }
  }
`;
export const ButtonContainer = styled.div`
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  margin-top: 16px;

  div {
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: clamp(14px, 3vw, 18px);
    line-height: 22.1px;
    font-family: ${fonts.regular};

    @media (min-width: ${breakpoints.tablet}) {
      width: 120px;
    }

    a {
      color: ${colors.$ffffff} !important;
    }
  }

  @media (min-width: ${breakpoints.tablet}) {
    flex-direction: column;
    font-size: 14px;
    margin-top: 18px;
  }

  @media (min-width: ${breakpoints.bigDesktop}) {
    margin-top: 0;
    flex-direction: row;
    width: 100%;
  }
`;

